export const HEADER_HEIGHT = 64;
export const FOOTER_HEIGHT = 58;
// Chrome outside `main`; full-height content uses calc(100vh - APP_CHROME_HEIGHT) to avoid a scrollbar.
export const APP_CHROME_HEIGHT = HEADER_HEIGHT + FOOTER_HEIGHT;

export const SUB_HEADER_STICKY_POSITION = 0;
export const SUB_HEADER_HEIGHT = 114;
export const SUB_HEADER_HEIGHT_NO_NAV = 80;
export const SUB_HEADER_HEIGHT_WITH_WIDGET = 178;
export const SUB_HEADER_SUBNAV_HEIGHT = 50;
